import { render } from "./NavigationTab.vue?vue&type=template&id=142d9644"
import script from "./NavigationTab.vue?vue&type=script&lang=ts"
export * from "./NavigationTab.vue?vue&type=script&lang=ts"
script.render = render

export default script